<template>
  <b-container >
    <div class="d-flex justify-content-between mx-2 my-3">
      <b-link  :to="linkto" > <b-icon icon="chevron-left" ></b-icon>{{ linkttitle }}</b-link>
      <h5 class="text-center mx-auto ">{{title}}</h5>
      <div></div>
    </div>
  </b-container>
</template>
<script>

export default {
  name: 'PageHeader',
  props: {
    title:String,
    linkto:String,
    linkttitle:String,
  },
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
